import { API } from "config";
import type { Message } from "types/Message";
import request from "utilities/request";

const baseUrl = API.dbApi.url;

/**
 * Returns the messages stored in a single chat thread.
 */
export async function getThreadMessages(
  threadId: string,
  getAccessToken: () => Promise<string>
): Promise<{ messages: Message[] }> {
  const accessToken = await getAccessToken();
  const url = `${baseUrl}/threads/${threadId}/messages`;

  const headers = { Authorization: `Bearer ${accessToken}` };
  const options = { method: "GET", headers };

  const response = await request(url, options);
  return (await response.json()) as { messages: Message[] };
}
